<script setup>
  import { computed, nextTick, onMounted, ref } from 'vue';
  import SwiperBase from '@/components/Utility/SwiperBase.vue';
  import HeroItem from '@/components/Paragraphs/HeroItem.vue';
  import SmallHeroItem from '@/components/Paragraphs/SmallHeroItem.vue';

  const indicatorSpacing = ref(10)
  const activeIndex = ref(0)
  const headerHeight = ref(0)

  const props = defineProps({
    items: String,
    smallHeight: String
  })

  const items = computed(() => {
    if (!props.items) return false
    return JSON.parse(props.items)
  })

  const smallHeight = computed(() => {
    if (!props.smallHeight) return false
    return JSON.parse(props.smallHeight)
  })

  const handleSlideChange = (index) => {
    activeIndex.value = index
  }

  const getActiveOffset = (index) => {
    if (!items.value) return false
    return {
      bottom: `calc(${50 - (.8 * (index))}%)`
    }
  }

  onMounted(async () => {
    await nextTick();

    const header = document.querySelector('.header-inner')
    if (!header) return false
    headerHeight.value = header.offsetHeight
  })

  const getOffset = (index) => {
    if (!items.value) return false
    return {
      bottom: `calc(${indicatorSpacing.value * (index)}px)`
    }
  }

  const calculateHeight = computed(() => {
    return {
      height: `calc(100% - ${headerHeight.value}px)`
    }
  })
</script>

<template>
  <section
    class="element-hero relative w-full overflow-hidden"
  >
    <div
      v-if="items.length > 1"
      class="h-screen"
    >
      <SwiperBase
        theme="hero"
        @handleSlideChange="handleSlideChange"
      >
        <template #slides>
          <HeroItem
            v-for="(item,index) in items"
            :key="index"
            :item="item"
          />
        </template>
      </SwiperBase>
      <div
        class="element-hero-indicator z-10 pointer-events-none absolute bottom-0 left-0 right-0 w-full h-full"
      >
        <div
          class="element-hero-indicator-line w-px bg-white/30 absolute bottom-0 right-10 lg:left-0 lg:right-0 lg:mx-auto"
          :style="calculateHeight"
        />
        <AppIcon
          v-for="i, index in items.length"
          :key="index"
          name="LogoPart"
          :style="activeIndex >= index ? getActiveOffset(i) : getOffset(i)"
          class="absolute transition-all duration-500 z-10 right-6 lg:right-auto lg:left-1/2 lg:-translate-x-1/2 mx-auto"
        />
      </div>
    </div>
    <div
      v-else
      class="xl:h-full xl:max-h-[50rem]"
    >
      <SmallHeroItem
        v-for="(item,index) in items"
        :key="index"
        :item="item"
      />
    </div>

  </section>
</template>

<style lang="scss" scoped>
.element-hero-indicator {
  :deep(svg) {
    @apply ~h-8/10 ~w-8/10;
  }
}
</style>
